<template>
  <main>
    <div class="row justify-content-between align-items-center">
      <div class="col-6">
        <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Feedback
          &
          Complaint Detail</a>
      </div>
      <div class="col-1 text-right">
        <div class="d-flex justify-content-end">
          <div class="dropdown">
            <a @click.prevent="dropdown.download = !dropdown.download" role="button" id="main-user"
              data-bs-toggle="dropdown" aria-expanded="false">
              <img style="width: 24px; height: 24px; display: block;" src="@/assets/icons/print.svg" alt="file">
            </a>
            <ul class="dropdown-menu dropdown-menu-end" style="right: 0; min-width: 16rem;"
              :class="{ 'show': dropdown.download }" aria-labelledby="main-user">
              <li><button @click="handlePrint('problem-investigation')" class="btn btn-transparent"
                  style="text-align: left;">Problem and Investigation Form</button>
              </li>
              <li><button @click="handlePrint('settlement')" class="btn btn-transparent"
                  style="text-align: left;">Settlement Form</button></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="detail?.version !== 1" class="row">
      <div class="col-12">
        <div class="white-box mm15 p30 py-3 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <Stepper :feedbackProcesses="detail?.feedbackProcesses" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 col-sm-5 col-xl-6">
        <DetailStatus />
        <div class="white-box mm15 p30">
          <div class="ft-16 font-bold mb15">Problem Description</div>

          <div class="popup-item wb pt-0">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">ID</div>
                <div>{{ detail?.id }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Date</div>
                <span>{{ moment(detail?.date_time, 'YYYY-MM-DD').format('DD MMM YYYY, HH:MM') }} WIB</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Type</div>
                <div>{{ detail?.type }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Description</div>
                <div>{{ detail?.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6">
                <div class="grey">Photo</div>
                <img :src="detail?.photos" alt="photo-fnc" class="w-100" />
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Category</div>
                <div>{{ detail?.category?.name }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Priority</div>
                <span>
                  <div class="status mt-1"
                    :style="`background-color: #27AE601a;color: #27AE60;text-transform: Capitalize;`">
                    {{ detail?.priority }}
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12 col-12">
                <div class="grey">Assigned to</div>
                <div v-for="employee in detail?.assigneds" :key="employee.id" class="status ori"
                  style="margin-right: 3px;">{{ employee?.assignee?.code ?? employee?.assignee?.name }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Customer</div>
                <div>{{ detail?.customer?.name }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Product</div>
                <span>{{ detail?.product }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">PIC</div>
                <div>{{ detail?.pic?.name }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">No. HP PIC</div>
                <span>{{ detail?.no_hp_pic }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Grade</div>
                <div>{{ detail?.grade }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Location</div>
                <div>{{ detail?.location }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Shipment Date</div>
                <span>{{ moment(detail?.shipment_date, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Lot No.</div>
                <div>{{ detail?.lot_no }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Issue</div>
                <span>{{ detail?.issue }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Transporter</div>
                <div>{{ detail?.transporter?.name }}</div>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">No. Surat Jalan</div>
                <div>{{ detail?.no_surat_jalan }}</div>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">Tgl Surat Jalan</div>
                <span>{{ moment(detail?.tgl_surat_jalan, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item wb">
            <div class="row">
              <div class="col-sm-6 col-6">
                <div class="grey">Tanggal Deadline</div>
                <span>{{ moment(detail?.deadline_date, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</span>
              </div>
              <div class="col-sm-6 col-6">
                <div class="grey">End Product Application</div>
                <span>{{ detail?.end_product_application }}</span>
              </div>
            </div>
          </div>
          <div class="popup-item">
            <div class="row">
              <div class="col-sm-12">
                <div class="grey">Prepared by</div>
                <div>{{ detail?.prepared_by_detail?.name }}</div>
              </div>
            </div>
          </div>
          <div v-permissions="'Edit Feedback and Complaint'" class="popup-item">
            <div class="row">
              <div class="col-sm-12">
                <button @click="$router.push(`/feedback/edit/${detail?.id}`)"
                  class="btn btn-border-orange mm15 w-100">Edit Investigation Request</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="detail?.version !== 1" class="col-lg-7 col-sm-7 col-xl-6">
        <TemporarySolution />
        <InternalIssue
          v-if="(isShowSection(['internal', 'closed']) || !!detail?.status_internal) && detail?.workflows.some(workflow => workflow?.type?.value === 'internal_issue')" />
        <CustomerIssue
          v-if="(isShowSection(['customer', 'closed']) || !!detail?.status_customer) && detail?.workflows.some(workflow => workflow?.type?.value === 'customer_issue')" />
        <SettlementIssue
          v-if="(isShowSection(['internal', 'closed']) || !!detail?.status_settlement) && detail?.workflows.some(workflow => workflow?.type?.value === 'setlement_issue')" />
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment';
import CustomerIssue from "./Detail/CustomerIssue";
import InternalIssue from "./Detail/InternalIssue";
import SettlementIssue from "./Detail/SettlementIssue";
import DetailStatus from "./Detail/Status";
import Stepper from "./Detail/Stepper";
import TemporarySolution from "./Detail/TemporarySolution";
import { downloadFile } from '@/utils/fetch'
export default {
  name: "FeedbackComplaintDetail",
  components: {
    Stepper,
    TemporarySolution,
    CustomerIssue,
    InternalIssue,
    SettlementIssue,
    DetailStatus
  },
  data() {
    return {
      moment,
      dropdown: {
        download: false
      }
    }
  },
  computed: {
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
  },
  async created() {
    await this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
  },
  beforeDestroy() {
    this.$store.commit('CLEAR_FEEDBACK_COMPLAINT')
  },
  methods: {
    isShowSection(statuses) {
      return statuses.some(keyword => this.detail?.status?.value.includes(keyword))
    },
    async handlePrint(type) {
      await downloadFile({ path: `/fnc-download/${this.$route.params.id}/${type}`, fileType: 'xlsx' })
      this.dropdown.download = false
    }
  }
}
</script>
